module.exports = __webpack_public_path__ + "static/media/sravanthi.abbfbe23.jpg";